import SpriteSymbol from "../../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rabbitMQ",
  "use": "rabbitMQ-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"rabbitMQ\"><path d=\"M10.26 6.96V2.71c0-.39-.32-.71-.71-.71H8.17c-.39 0-.71.32-.71.71v4.25c0 .39-.32.71-.71.71h-.82c-.39 0-.71-.32-.71-.71V2.71c0-.39-.32-.71-.71-.71H3.2c-.39 0-.71.32-.71.71v12.58c0 .39.32.71.71.71h11.6c.39 0 .71-.32.71-.71V8.38c0-.39-.32-.71-.71-.71h-3.83c-.39 0-.71-.32-.71-.71zm2.66 5.54c0 .38-.31.7-.7.7h-1.27c-.38 0-.7-.31-.7-.7v-1.27c0-.38.31-.7.7-.7h1.27c.38 0 .7.31.7.7v1.27z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol